import styled from 'styled-components';

import { PlannedDuty, OpenDuty } from './types';

import {
  PRIMARY,
  SECONDARY,
  ORANGE,
  ORANGE_SECONDARY,
  GRAY
} from 'constants/colors';

import { getCellDateClasses } from '../utils';
import { brightness } from 'utils/misc';

import DutyEntry from './DutyEntry';

const StyledDayCell = styled.td`
  min-height: 80px;

  &:not(:last-child) {
    border-right: 1px dashed ${GRAY} !important;
  }

  .duty {
    margin: 8px;
    padding: 8px;
    border-radius: 6px;
    min-height: 60px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    position: relative;
    color: black;
    text-align: center;

    .icons {
      svg {
        margin: 4px 4px 0;
        width: 12px;
        height: 12px;
      }
    }

    &.planned {
      border: 1px solid ${PRIMARY};
      background-color: ${brightness(SECONDARY, 85)};
    }

    &.open {
      border: 1px solid ${ORANGE_SECONDARY};
      background-color: ${brightness(ORANGE, 85)};
    }

    .function-color {
      margin: 0 4px 0;
      width: 6px;
      height: 6px;
    }

    .periods {
      font-size: 11px;

      .dhts {
        .dht-code {
          display: inline-block;
          margin-right: 6px;
          position: relative;

          &::before {
            content: ',';
            position: absolute;
            top: 0;
            right: -2px;
          }

          &:last-child {
            margin-right: 0;

            &::before {
              display: none;
            }
          }
        }
      }
    }

    .has-subscribers {
      position: relative;

      .cnt {
        position: absolute;
        right: 0;
        top: 0;
        transform: translate(50%, -50%);
        font-size: 12px;
        line-height: 1;
      }
    }

    .top-right-icons {
      position: absolute;
      right: 5px;
      top: 5px;
      line-height: 1;
      display: flex;

      svg {
        width: 8px;
        height: 8px;

        &.dht-changed {
          width: 7px;
          height: 7px;
        }

        & + svg {
          margin-left: 2px;
        }
      }
    }

    &.is-faded {
      opacity: 0.5;
    }
  }
`;

type Props = {
  duties: (PlannedDuty | OpenDuty)[];
  date: Date;
  portal: string;
  isGroupedByPlanunit: boolean;
  isGroupedByFunction: boolean;
};

export default function DayCell({
  duties,
  date,
  portal,
  isGroupedByPlanunit,
  isGroupedByFunction
}: Props) {
  return (
    <StyledDayCell className={getCellDateClasses({ date }, ['day-cell'])}>
      {duties.map((duty) => (
        <DutyEntry
          duty={duty}
          key={duty.isOpen ? duty.requestId : duty.dutyLineId}
          portal={portal}
          isGroupedByPlanunit={isGroupedByPlanunit}
          isGroupedByFunction={isGroupedByFunction}
        />
      ))}
    </StyledDayCell>
  );
}
